<app-admin-header></app-admin-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div class="main-content p-t-20">
    <div class="container-fluid">
      <app-breadcrumb
        [items]="[{ label: 'Admin' }, { label: 'Groups' }]"
        [home]="{ label: 'Home', routerLink: '/home' }"
      ></app-breadcrumb>

      <div class="d-flex justify-content-between">
        <div class="m-b-20">
          <h1 class="font-medium text-70 m-b-0">Groups</h1>
        </div>

        <div class="search-box-wrapper">
          <ng-icon
            name="hugeSearch01"
            size="16"
            class="m-r-5 lh-1-0 text-70"
          ></ng-icon>
          <input
            class="radius-8 b2 wd-500px"
            type="text"
            [(ngModel)]="searchQuery"
            (input)="onFilterChange($event)"
            placeholder="Search"
          />
        </div>
        <div class="dis-flex">
          <button
            class="btn outline b2 wd-140px mx-2"
            (click)="exportGroups()"
            [disabled]="isDownloading"
          >
            <ng-icon class="lh-1-0 m-r-4" name="hugeDownload03" size="18" />
            <span *ngIf="isDownloading">Downloading...</span>
            <span *ngIf="!isDownloading">Download</span>
          </button>
          <button class="btn primary b2 wd-140px mx-2" (click)="addGroup()">
            <ng-icon class="lh-1-0 m-r-4" name="hugeAdd01" size="18" />Add Group
          </button>
        </div>
      </div>
      <p-scrollPanel
        [style]="{
          width: '100%',
          height: 'calc(100vh - 28vh)',
          paddingBottom: '25px'
        }"
      >
        <ng-container *ngIf="!isGroupLoading; else loadigData">
          <ng-container
            *ngIf="
              (chapters?.length ?? 0) > 0 ||
                (clusters?.length ?? 0) > 0 ||
                (functions?.length ?? 0) > 0;
              else noDataFound
            "
          >
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 28vh)' }"
            >
              <div class="content" *ngIf="chapters?.length">
                <h3 class="font-medium text-70 m-l-5">Chapter</h3>

                <div class="flex flex-wrap">
                  <app-group-card
                    *ngFor="let chapter of chapters"
                    [groupName]="chapter"
                    title="Chapter"
                    (click)="showData(chapter)"
                  ></app-group-card>
                </div>
              </div>

              <div class="content m-t-20" *ngIf="clusters?.length">
                <h3 class="font-medium text-70 m-l-5">Cluster</h3>
                <div class="flex flex-wrap">
                  <app-group-card
                    *ngFor="let cluster of clusters"
                    [groupName]="cluster"
                    title="Cluster"
                    (click)="showData(cluster)"
                  ></app-group-card>
                </div>
              </div>

              <div class="content m-t-20" *ngIf="functions?.length">
                <h3 class="font-medium text-70 m-l-5">Function</h3>

                <div class="flex flex-wrap">
                  <app-group-card
                    *ngFor="let function of functions"
                    [groupName]="function"
                    title="Function"
                    (click)="showData(function)"
                  ></app-group-card>
                </div>
              </div>
            </p-scrollPanel>
          </ng-container>
        </ng-container>
      </p-scrollPanel>
    </div>
  </div>
</div>

<div class="group-details">
  <p-dialog
    class="action-item-modal b1 font-medium"
    header="{{ this.group.name }}"
    [modal]="true"
    [(visible)]="visibleChapter"
    [style]="{ width: '80rem' }"
  >
    <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
      <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div
          class="groups-form-container radius-8 border-20 p-t-15 p-b-15 p-l-15 p-r-15"
        >
          <p-scrollPanel
            [style]="{ width: '100%', height: 'calc(100vh - 45vh)' }"
          >
            <p class="b2 font-medium">Core Members</p>
            <div class="row">
              <!-- Need to add Child data -->
              <div
                class="col-md-6"
                *ngIf="
                  this.group?.link == 'child' && this.group?.type == 'function'
                "
              >
                <label class="b3 text-90"
                  >Parent Functional Director
                  <span class="mandatory">*</span></label
                >
                <p-dropdown
                  [options]="users"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="parent_group_id"
                  placeholder="Select a Parent Functional Director"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                  optionLabel="name"
                >
                  <ng-template let-value pTemplate="selectedItem">
                    <div
                      class="flex align-items-center gap-1 m-r-10"
                      *ngIf="value"
                    >
                      <img
                        [src]="value.avatar || helper.defaultImageUrl"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ value.name }}</div>
                    </div>
                  </ng-template>

                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-1 m-r-10">
                      <img
                        [src]="user.avatar || helper.defaultImageUrl"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

                @if(formGroup.get('parent_group_id')?.invalid &&
                (formGroup.get('parent_group_id')?.touched ||
                formGroup.get('parent_group_id')?.dirty)) {
                @if(formGroup.get('parent_group_id')?.hasError('required')) {
                <span class="text-danger"
                  >Parent Functional Director is required</span
                >
                } }
              </div>

              <div
                *ngIf="this.group"
                [ngClass]="
                  this.group.type === 'chapter' ? 'col-md-12' : 'col-md-6'
                "
              >
                <label
                  *ngIf="this.group"
                  [ngSwitch]="this.group.type"
                  class="b3 text-90"
                >
                  <span *ngSwitchCase="'chapter'">Chapter Lead</span>
                  <span *ngSwitchCase="'cluster'">Cluster Head</span>
                  <span *ngSwitchCase="'function'">Functional Director</span>
                  <span *ngSwitchDefault="">Lead</span>
                  <span class="mandatory"> *</span>
                </label>
                <!-- <p-multiSelect [options]="users" display="chip" [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="coreMembers" placeholder="Select a User" optionLabel="name" [showClear]="true"
                  selectionLimit="1" [maxSelectedLabels]="1">
                  <ng-template let-value pTemplate="selectedItems">
                    <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                      <img src="{{ option.avatar || helper.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ option.name }},</div>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img src="{{ user.avatar || user.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect> -->
                <p-dropdown
                  [options]="users"
                  [overlayOptions]="helper.getOverlayOptions()"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                  formControlName="coreMembers"
                  placeholder="Select a User"
                  optionLabel="name"
                >
                  <!-- Selected Item Template -->
                  <ng-template let-value pTemplate="item">
                    <div class="flex align-items-center gap-1 m-r-10">
                      <img
                        [src]="value.avatar || helper.defaultImageUrl"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ value.name }}</div>
                    </div>
                  </ng-template>

                  <!-- Dropdown List Items -->
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-1 m-r-10">
                      <img
                        [src]="user.avatar || helper.defaultImageUrl"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

                @if(formGroup.get('coreMembers')?.invalid &&
                (formGroup.get('coreMembers')?.touched ||
                formGroup.get('coreMembers')?.dirty)) {
                @if(formGroup.get('coreMembers')?.hasError('required')) {
                <span class="text-danger"> Members are required</span>
                } }
              </div>

              <div class="col-md-6" *ngIf="this.group?.type != 'chapter'">
                <label class="b3 text-90"
                  >SPOC <span class="mandatory">*</span></label
                >
                <!-- <p-multiSelect [options]="users" [overlayOptions]="helper.getOverlayOptions()" display="chip"
                  formControlName="spocuser" placeholder="Select a SPOC" optionLabel="name" [showClear]="true"
                  selectionLimit="1" [maxSelectedLabels]="1">
                  <ng-template let-value pTemplate="selectedItems">
                    <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                      <img src="{{ option.avatar || helper.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ option.name }},</div>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img src="{{ user.a vatar || helper.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect> -->

                <p-dropdown
                  [options]="users"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="spocuser"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                  placeholder="Select a SPOC"
                  optionLabel="name"
                >
                  <!-- Selected Item Template -->
                  <ng-template let-value pTemplate="item">
                    <div class="flex align-items-center gap-1 m-r-10">
                      <img
                        [src]="value.avatar || helper.defaultImageUrl"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ value.name }}</div>
                    </div>
                  </ng-template>

                  <!-- Dropdown List Items -->
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-1 m-r-10">
                      <img
                        [src]="user.avatar || helper.defaultImageUrl"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

                @if(formGroup.get('spocuser')?.invalid &&
                (formGroup.get('spocuser')?.touched ||
                formGroup.get('spocuser')?.dirty)) {
                @if(formGroup.get('spocuser')?.hasError('required')) {
                <span class="text-danger">Spocuser are required</span>
                } }
              </div>
            </div>

            <div class="row m-t-20">
              <div class="col-md-12">
                <label class="b3 text-90"
                  >Members <span class="mandatory">*</span></label
                >
                <p-multiSelect
                  [options]="users"
                  display="chip"
                  formControlName="members"
                  placeholder="Select a User"
                  optionLabel="name"
                  [overlayOptions]="helper.getOverlayOptions()"
                  class="flex-wrap"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                >
                  <ng-template let-value pTemplate="selectedItems">
                    <div
                      class="inline-flex align-items-center gap-1 m-r-10 m-b-10 removable-value-dd px-1"
                      *ngFor="let option of value"
                    >
                      <img
                        src="{{ option.avatar || helper.defaultImageUrl }}"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ option.name }}</div>
                      <button
                        type="button"
                        class="remove-button m-l-5 fs-13 radius-22"
                        (click)="removeMember(option)"
                      >
                        ✖
                      </button>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div
                      class="flex align-items-center gap-1 m-r-10 m-b-10 removable-value-dd"
                    >
                      <img
                        src="{{ user.avatar || helper.defaultImageUrl }}"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>
                @if(formGroup.get('members')?.invalid &&
                (formGroup.get('members')?.touched ||
                formGroup.get('members')?.dirty)) {
                @if(formGroup.get('members')?.hasError('required')) {
                <span class="text-danger"> Members are required</span>
                } }
              </div>
            </div>

            <hr class="m-t-25 m-b-20" />

            <p class="b2 font-medium">
              Provide access for users to view this Function
            </p>
            <div class="row">
              <div class="col-md-12">
                <label class="b3 text-90">Viewers</label>
                <p-multiSelect
                  [options]="users"
                  display="chip"
                  formControlName="viewers"
                  placeholder="Select a User"
                  optionLabel="name"
                  [showClear]="true"
                  [overlayOptions]="helper.getOverlayOptions()"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                >
                  <ng-template let-value pTemplate="selectedItems">
                    <div
                      class="inline-flex align-items-center gap-2 px-1 removable-value-dd"
                      *ngFor="let option of value"
                    >
                      <img
                        src="{{ option.avatar || helper.defaultImageUrl }}"
                        style="width: 18px"
                      />
                      <div>{{ option.name }}</div>
                      <button
                        type="button"
                        class="remove-button m-l-5 fs-13 radius-22"
                        (click)="removeViewers(option)"
                      >
                        ✖
                      </button>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div
                      class="flex align-items-center gap-2 removable-value-dd"
                    >
                      <img
                        src="{{ user.avatar || helper.defaultImageUrl }}"
                        style="width: 18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
            <div *ngIf="parentFunction[0]">
              <hr class="m-t-25 m-b-20" />
              <h3>Parent</h3>
              <div class="flex flex-wrap">
                <app-group-card
                  *ngFor="let function of parentFunction"
                  [groupName]="function"
                  title="Function"
                  (click)="showData(function)"
                ></app-group-card>
              </div>
            </div>

            <div *ngIf="childFunction.length > 0">
              <hr class="m-t-25 m-b-20" />
              <h3>Child</h3>
              <div class="flex flex-wrap">
                <app-group-card
                  *ngFor="let function of childFunction"
                  [groupName]="function"
                  title="Function"
                  (click)="showData(function)"
                ></app-group-card>
              </div>
            </div>
          </p-scrollPanel>
        </div>
        <div class="dis-flex flex-r">
          <button class="btn primary wd-150px m-t-20 m-b-10 save-btn">
            Save
          </button>
        </div>
      </form>
    </div>
  </p-dialog>
</div>

<div class="group-details">
  <p-dialog
    class="action-item-modal b1 font-medium"
    header="{{ this.group.name }}"
    [modal]="true"
    [(visible)]="isGroupAdded"
    [style]="{ width: '80rem' }"
  >
    <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
      <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div
          class="groups-form-container radius-8 border-20 p-t-15 p-b-15 p-l-15 p-r-15"
        >
          <p-scrollPanel
            [style]="{ width: '100%', height: 'calc(100vh - 45vh)' }"
          >
            <div class="row">
              <div class="col-md-12 mb-3">
                <div class="dis-flex flex-col">
                  <label class="b3 text-90"
                    >Name <span class="mandatory">*</span></label
                  >
                  <input
                    class="b3 text-90"
                    id="value"
                    name="value"
                    placeholder="Enter Name"
                    type="text"
                    formControlName="name"
                  />
                </div>
                <div
                  *ngIf="
                    formGroup.controls['name'].touched &&
                    formGroup.controls['name'].invalid
                  "
                  class="text-danger small"
                >
                  Name is required.
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="b3 text-90"
                  >Link <span class="mandatory">*</span></label
                >
                <p-dropdown
                  [options]="linkOptions"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="link"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="onLinkChange()"
                  placeholder="Select a Link"
                >
                </p-dropdown>
                <div
                  *ngIf="
                    formGroup.controls['link'].touched &&
                    formGroup.controls['link'].invalid
                  "
                  class="text-danger small"
                >
                  Link is required.
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="b3 text-90"
                  >Type <span class="mandatory">*</span></label
                >
                <p-dropdown
                  [options]="typeOptions"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="type"
                  optionLabel="label"
                  (onChange)="onTypeChange()"
                  optionValue="value"
                  placeholder="Select a Type"
                >
                </p-dropdown>
                <div
                  *ngIf="
                    formGroup.controls['type'].touched &&
                    formGroup.controls['type'].invalid
                  "
                  class="text-danger small"
                >
                  Type is required.
                </div>
              </div>
              <p class="b2 font-medium">Core Members</p>

              <div
                class="col-md-6 mb-3"
                *ngIf="
                  formGroup.get('link')?.value == 'parent' &&
                  formGroup.get('type')?.value
                "
              >
                <label class="b3 text-90"
                  >Child <span class="mandatory">*</span></label
                >
                <p-multiSelect
                  [options]="childData"
                  display="chip"
                  formControlName="childs"
                  placeholder="Select a User"
                  optionLabel="name"
                  [overlayOptions]="helper.getOverlayOptions()"
                  class="flex-wrap"
                  filter="true"
                  (onFilter)="onChildGroupSearch($event)"
                >
                  <ng-template let-value pTemplate="selectedItems">
                    <div
                      class="inline-flex align-items-center gap-2 px-1"
                      *ngFor="let option of value"
                    >
                      <div>{{ option.name }}</div>
                      <button
                        type="button"
                        class="remove-button m-l-5 fs-13 radius-22"
                        (click)="removeChildGroup(option)"
                      >
                        ✖
                      </button>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Group</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>

              <!-- Need to add Child data -->
              <div
                class="col-md-6"
                *ngIf="formGroup.get('link')?.value == 'child'"
              >
                <label class="b3 text-90"
                  >Parent Group <span class="mandatory">*</span></label
                >
                <p-dropdown
                  [options]="parentGroupArray"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="parent_group_id"
                  placeholder="Select a Parent Functional Director"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                  optionLabel="name"
                >
                  <ng-template let-value pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="value">
                      <div>{{ value.name }}</div>
                    </div>
                  </ng-template>

                  <ng-template let-parent pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ parent.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

                @if(formGroup.get('parent_group_id')?.invalid &&
                (formGroup.get('parent_group_id')?.touched ||
                formGroup.get('parent_group_id')?.dirty)) {
                @if(formGroup.get('parent_group_id')?.hasError('required')) {
                <span class="text-danger">Parent Group is required</span>
                } }
              </div>

              <div
                [ngClass]="
                  formGroup.get('type')?.value === 'chapter'
                    ? 'col-md-12'
                    : 'col-md-6'
                "
              >
                <label
                  [ngSwitch]="formGroup.get('type')?.value"
                  class="b3 text-90"
                >
                  <span *ngSwitchCase="'chapter'">Chapter Lead</span>
                  <span *ngSwitchCase="'cluster'">Cluster Head</span>
                  <span *ngSwitchCase="'function'">Functional Director</span>
                  <span *ngSwitchDefault="">Lead</span>
                  <span class="mandatory"> *</span>
                </label>
                <!-- <p-multiSelect [options]="users" display="chip" [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="coreMembers" placeholder="Select a User" optionLabel="name" [showClear]="true"
                  selectionLimit="1" [maxSelectedLabels]="1">
                  <ng-template let-value pTemplate="selectedItems">
                    <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                      <img src="{{ option.avatar || helper.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ option.name }},</div>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img src="{{ user.avatar || user.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect> -->
                <p-dropdown
                  [options]="users"
                  [overlayOptions]="helper.getOverlayOptions()"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                  formControlName="coreMembers"
                  placeholder="Select a User"
                  optionLabel="name"
                >
                  <!-- Selected Item Template -->
                  <ng-template let-value pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2">
                      <img
                        [src]="value.avatar || helper.defaultImageUrl"
                        style="width: 18px"
                      />
                      <div>{{ value.name }}</div>
                    </div>
                  </ng-template>

                  <!-- Dropdown List Items -->
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img
                        [src]="user.avatar || helper.defaultImageUrl"
                        style="width: 18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

                @if(formGroup.get('coreMembers')?.invalid &&
                (formGroup.get('coreMembers')?.touched ||
                formGroup.get('coreMembers')?.dirty)) {
                @if(formGroup.get('coreMembers')?.hasError('required')) {
                <span class="text-danger"> Members are required</span>
                } }
              </div>

              <div
                class="col-md-6"
                *ngIf="formGroup.get('type')?.value != 'chapter'"
              >
                <label class="b3 text-90"
                  >SPOC <span class="mandatory">*</span></label
                >
                <!-- <p-multiSelect [options]="users" [overlayOptions]="helper.getOverlayOptions()" display="chip"
                  formControlName="spocuser" placeholder="Select a SPOC" optionLabel="name" [showClear]="true"
                  selectionLimit="1" [maxSelectedLabels]="1">
                  <ng-template let-value pTemplate="selectedItems">
                    <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                      <img src="{{ option.avatar || helper.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ option.name }},</div>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img src="{{ user.a vatar || helper.defaultImageUrl }}" style="width: 18px" />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect> -->

                <p-dropdown
                  [options]="users"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="spocuser"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                  placeholder="Select a SPOC"
                  optionLabel="name"
                >
                  <!-- Selected Item Template -->
                  <ng-template let-value pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2">
                      <img
                        [src]="value.avatar || helper.defaultImageUrl"
                        style="width: 18px"
                      />
                      <div>{{ value.name }}</div>
                    </div>
                  </ng-template>

                  <!-- Dropdown List Items -->
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img
                        [src]="user.avatar || helper.defaultImageUrl"
                        style="width: 18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

                @if(formGroup.get('spocuser')?.invalid &&
                (formGroup.get('spocuser')?.touched ||
                formGroup.get('spocuser')?.dirty)) {
                @if(formGroup.get('spocuser')?.hasError('required')) {
                <span class="text-danger">Spocuser are required</span>
                } }
              </div>
            </div>

            <div class="row m-t-20">
              <div class="col-md-12">
                <label class="b3 text-90"
                  >Members <span class="mandatory">*</span></label
                >
                <p-multiSelect
                  [options]="users"
                  display="chip"
                  formControlName="members"
                  placeholder="Select a User"
                  optionLabel="name"
                  [overlayOptions]="helper.getOverlayOptions()"
                  class="flex-wrap"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                >
                  <ng-template let-value pTemplate="selectedItems">
                    <div
                      class="inline-flex align-items-center gap-2 px-1 removable-value-dd"
                      *ngFor="let option of value"
                    >
                      <img
                        src="{{ option.avatar || helper.defaultImageUrl }}"
                        style="width: 18px"
                      />
                      <div>{{ option.name }}</div>
                      <button
                        type="button"
                        class="remove-button m-l-5 fs-13 radius-22"
                        (click)="removeMember(option)"
                      >
                        ✖
                      </button>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div
                      class="flex align-items-center gap-2 removable-value-dd"
                    >
                      <img
                        src="{{ user.avatar || helper.defaultImageUrl }}"
                        style="width: 18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>
                @if(formGroup.get('members')?.invalid &&
                (formGroup.get('members')?.touched ||
                formGroup.get('members')?.dirty)) {
                @if(formGroup.get('members')?.hasError('required')) {
                <span class="text-danger"> Members are required</span>
                } }
              </div>
            </div>

            <hr class="m-t-25 m-b-20" />

            <p class="b2 font-medium">
              Provide access for users to view this Function
            </p>
            <div class="row">
              <div class="col-md-12">
                <label class="b3 text-90">Viewers</label>
                <p-multiSelect
                  [options]="users"
                  display="chip"
                  formControlName="viewers"
                  placeholder="Select a User"
                  optionLabel="name"
                  [showClear]="true"
                  [overlayOptions]="helper.getOverlayOptions()"
                  filter="true"
                  (onFilter)="onCoreMemberSearch($event)"
                >
                  <ng-template let-value pTemplate="selectedItems">
                    <div
                      class="inline-flex align-items-center gap-1 m-r-10 m-b-10 removable-value-dd px-1"
                      *ngFor="let option of value"
                    >
                      <img
                        src="{{ option.avatar || helper.defaultImageUrl }}"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ option.name }}</div>
                      <button
                        type="button"
                        class="remove-button m-l-5 fs-13 radius-22"
                        (click)="removeViewers(option)"
                      >
                        ✖
                      </button>
                    </div>
                    <div *ngIf="!value || value.length === 0">Select Users</div>
                  </ng-template>
                  <ng-template let-user pTemplate="item">
                    <div
                      class="flex align-items-center gap-1 m-r-10 m-b-10 removable-value-dd"
                    >
                      <img
                        src="{{ user.avatar || helper.defaultImageUrl }}"
                        class="radius-4 wd-18px"
                      />
                      <div>{{ user.name }}</div>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>

            <div *ngIf="parentFunction[0]">
              <hr class="m-t-25 m-b-20" />
              <h3>Parent</h3>
              <div class="flex flex-wrap">
                <app-group-card
                  *ngFor="let function of parentFunction"
                  [groupName]="function"
                  title="Function"
                  (click)="showData(function)"
                ></app-group-card>
              </div>
            </div>

            <div *ngIf="childFunction.length > 0">
              <hr class="m-t-25 m-b-20" />
              <h3>Child</h3>
              <div class="flex flex-wrap">
                <app-group-card
                  *ngFor="let function of childFunction"
                  [groupName]="function"
                  title="Function"
                  (click)="showData(function)"
                ></app-group-card>
              </div>
            </div>
          </p-scrollPanel>
        </div>
        <div class="dis-flex flex-r">
          <button
            class="btn primary wd-150px m-t-20 m-b-10 save-btn"
            [disabled]="formGroup.invalid"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  </p-dialog>
</div>

<ng-template #loadigData>
  <app-shimmer-list [count]="15"></app-shimmer-list>
</ng-template>

<ng-template #noDataFound>
  <app-no-data-found></app-no-data-found>
</ng-template>
